import { render, staticRenderFns } from "./Page025.vue?vue&type=template&id=68e13aaa&scoped=true&"
import script from "./Page025.vue?vue&type=script&lang=js&"
export * from "./Page025.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68e13aaa",
  null
  
)

export default component.exports